import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import Input from 'components/base/Input';
import Button from 'components/base/Button';
import request from 'utils/https-request';

export default function Admin() {
  const navigate = useNavigate();
  const { register, setValue, handleSubmit } = useForm();

  const onSubmit = async data => {
    console.log(data);
  };

  useEffect(() => {}, []);
  return (
    <div className="flex flex-auto items-center justify-center">
      <form className="border bg-white p-8 text-center" onSubmit={handleSubmit(onSubmit)}>
        <p className="text-2xl font-bold">비밀번호</p>
        <Input
          className="mb-2 mt-4 w-32 text-xl"
          type="password"
          register={register('password', {
            onChange: e => {
              setValue('password', e.target.value.replace(/\s/g, ''));
            },
          })}
        />
        <Button className="mx-auto" type="submit">
          전송
        </Button>
      </form>
    </div>
  );
}
